import App from "../app";
import {
  EventConfig,
  Event,
  EventAPIConfig,
  EventAPIReturnOptions,
} from "../interfaces";
const HOST =
  process.env.NODE_ENV === "production"
    ? "http://events.bsi-sc.com"
    : "http://127.0.0.1:9000";
import { ICore } from "~/core/core";
const core = App.Core<ICore>();

const api = App.API({
  options: {
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  },
  // baseURL: `${HOST}`,
  path: "auth",
});

export default {
  getId: async (): Promise<any> => await api.post("id", {}),
  getSession: async (): Promise<any> => await api.post(`session`, {}),
  logout: async (): Promise<any> =>
    await api.post(`logout`, { user: core.user.state.name.value }),
};
